import { oxfordJoin } from 'common/StringUtils';
import React from 'react';
import { Link } from 'react-router-dom';
import { CapacityMessage } from 'src/pages/consumer/order/components/ConsumerOrderCartCapacityWarning';
import { useHomePath } from 'src/shared/hooks/useHomePath';

interface IShefsUnavailableErrorProps {
  shefNames: string[];
}

export const ShefsUnavailableError: React.FC<IShefsUnavailableErrorProps> = ({ shefNames }) => {
  const path = useHomePath();

  const errorText =
    shefNames.length === 1
      ? `Shef ${shefNames[0]} is no longer unavailable and has been removed from your cart.`
      : `Shefs ${oxfordJoin(shefNames)} are no longer available and have been removed from your cart.`;
  return (
    <>
      <CapacityMessage type='error'>
        <h3>Checkout error</h3>
        <span>{errorText}</span>
        <span className='mt-2 block underline'>
          <Link className='hover:text-plum-600' to={path}>
            Explore more dishes
          </Link>
        </span>
      </CapacityMessage>
    </>
  );
};
